import NiotaClassicApiService from '../../../services/niotaClassicApiService';
import { mapState } from 'vuex';
import formMixin from '../formMixin';
import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';
import get from 'lodash/get';
export default {
  name: 'NiotaClassicApplicationsForm',
  mixins: [formMixin],
  props: {
    editedItem: {
      type: Object,
      required: false,
      default: null
    },
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      plainAccounts: [],
      diagramPeriods: [2, 3, 4, 5, 6, 7, 14, 31].map(days => {
        return {
          text: `${this.$i18n_t('NiotaClassic.Applications.form.from')} ${days} ${this.$i18n_t('NiotaClassic.Applications.form.days')}`,
          value: days
        };
      }),
      urlRule: [v => /http(s?):\/\/([a-z0-9]+)\.([a-z]+)/.test(v) || 'Enter a valid URL'],
      addressObject: {
        address: '',
        coordinates: [null, null]
      }
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    coordinateLookup() {
      return get(this.formItem, 'properties.coordinateMode') !== 'manual';
    }
  },
  created() {
    this.formItem = cloneDeep(this.editedItem) || {};
    this.setAddressObject();
    if (!get(this.formItem, 'properties.detailsViewCards')) {
      set(this.formItem, 'properties.detailsViewCards', {});
    }
    this.getPlainAccounts();
  },
  methods: {
    createOrUpdateApplication() {
      if (this.formItem.id) {
        this.updateRequest();
      } else {
        this.createRequest();
      }
    },
    tagsChanged(tags) {
      this.formItem.tags = tags;
    },
    updateRequest() {
      return NiotaClassicApiService.applicationsUpdate(this.formItem.id, this.formItem).then(res => {
        if (!res.data.err) {
          this.$snack(this.$i18n_t('NiotaClassic.Applications.form.successfulUpdate'), 'success');
          this.$emit('update', this.formItem);
          this.$emit('close');
          this.$emit('refreshList');
        } else {
          this.$snack(res.data.err, 'error');
        }
      }).catch(error => {
        this.$snack(get(error, 'response.data.err'), 'error');
        console.error(error);
      });
    },
    createRequest() {
      NiotaClassicApiService.applicationsCreate(this.formItem).then(() => {
        this.$emit('created');
        this.$emit('close');
        this.$snack(this.$i18n_t('NiotaClassic.Applications.snacks.createSuccess'), 'success');
      }).catch(() => {
        this.$snack(this.$i18n_t('NiotaClassic.Applications.snacks.createFailed'), 'error');
      });
    },
    getPlainAccounts() {
      NiotaClassicApiService.accountsFetchPlain().then(res => {
        this.plainAccounts = res.data.accounts;
        if (this.formItem.accountId) {
          this.formItem.account = this.plainAccounts.find(account => account.id === this.formItem.accountId);
        }
      }).catch(() => {
        this.$snack(this.$i18n_t('NiotaClassic.Applications.snacks.fetchAccountFailed'), 'error');
      });
    },
    getFile(file) {
      this.formData = new FormData(); // Muss neu erzeugt werden gegen Duplikate
      this.file = file;
      this.formData.append('file', this.file);
    },
    filterAccounts(item, queryText) {
      return item.name.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 || item.id.toString().toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1;
    },
    uploadImage(image) {
      NiotaClassicApiService.uploadImage(image, 'originator').then(data => {
        this.formItem.image = data.file;
        this.formItem = cloneDeep(this.formItem);
      }).catch(error => {
        // TODO: create toast with error message
        console.error('Error during image upload', error);
      });
    },
    accountUpdated() {
      if (this.formItem.account) {
        this.formItem.accountId = this.formItem.account.id;
      }
    },
    setAddressObject() {
      this.addressObject = {
        address: {
          formatted_address: this.formItem.applicationAddress
        },
        coordinates: [this.formItem.lon || null, this.formItem.lat || null]
      };
    },
    addressSelected(addressData) {
      this.formItem.applicationAddress = addressData.address;
      [this.formItem.lon, this.formItem.lat] = addressData.coordinates;
      this.formItem.properties = {
        ...(this.formItem.properties || {}),
        coordinateMode: addressData.pickedManualCoordinates ? 'manual' : 'auto'
      };
      this.setAddressObject();
    }
  }
};